import { css } from '@emotion/core'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import parse from 'html-react-parser'
import React from 'react'

import { Link } from './../../Link'

interface Props {
  logoSrc: {
    gatsbyImageData: IGatsbyImageData
    title: string
  }
  title: string
  stripColor: string
  url: string
}

const LearnCategoryTab: React.FunctionComponent<Props> = ({ logoSrc, title, stripColor, url }) => {
  return (
    <Link href={url} css={containerStyle(stripColor)}>
      {logoSrc && (
        <GatsbyImage image={logoSrc.gatsbyImageData} alt={logoSrc.title} css={imageStyle} loading={'eager'} />
      )}
      <div className={'categories left'}>{parse(title)}</div>
    </Link>
  )
}

export default LearnCategoryTab

const containerStyle = (stripColor: string) => css`
  display: grid;
  grid-template-columns: 3rem auto;
  align-items: center;
  max-width: 15.3rem;
  width: 100%;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 0.25rem;
  border-right: 4px solid ${stripColor};

  .categories {
    margin: 0 1rem 0 0;
  }

  &:hover {
    cursor: pointer;
    background: rgba(255, 255, 255, 0.06);
  }
`

const imageStyle = css`
  transform: translateX(-50%);
  margin: 0.75rem 0;
`
